import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { UserGroupFindDto, type UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { booleanSchema } from '@zaoblako/shared/modules/serde/schemas/boolean.schema';

import * as yup from 'yup';

/** Unit response body */
export interface UnitFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /**
   * Auto generated create datetime
   */
  created: Date;
  /**
   * Relation to user who created unit
   */
  createdBy?: UserFindInterface;
  /**
   * Auto generated update datetime
   */
  updated: Date;
  /**
   * Unit name
   */
  name: string;
  /** Unit short name */
  short: string;
  /** Unit soft deletion mark */
  deleted: boolean;
  /** Unit color */
  color: string;
  /** Identifier of this unit in Atrium CRM */
  atriumId?: number;
  /** Special code of this unit for Atrium CRM (using by some reports) */
  atriumCode: string;
  /** Is unit exported to Atrium CRM */
  exportedToAtrium?: boolean;
  /** Is this unit using to distribute costs (`true` value must be a single for tenant) */
  distributeCosts?: boolean;
  /** Users who have access to this unit */
  users?: UserFindInterface[];
  /** User groups whose members have access to this unit */
  userGroups?: UserGroupFindInterface[];
}

/** Unit response body DTO */
export const UnitFindDto = SerdeDtoClass.create<UnitFindInterface>(CatalogDtosKeysEnum.UNIT_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создана',
    serializer: yup.date(),
  },
  createdBy: {
    optional: true,
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  updated: {
    label: 'Изменена',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  short: {
    optional: true,
    sortable: true,
    label: 'Сокращенное название',
    serializer: yup.string(),
  },
  deleted: {
    label: 'Помечен удаленным',
    serializer: booleanSchema,
  },
  color: {
    optional: true,
    label: 'Цвет',
    serializer: yup.string(),
  },
  atriumId: {
    optional: true,
    label: 'Номер в "Атриум CRM"',
    serializer: yup.number(),
  },
  atriumCode: {
    label: 'Код для "Атриума"',
    optional: true,
    serializer: yup.string(),
  },
  exportedToAtrium: {
    optional: true,
    label: 'Синхронизирован с "Атриум CRM"',
    serializer: booleanSchema,
  },
  distributeCosts: {
    optional: true,
    label: 'Распределить затраты',
    serializer: booleanSchema,
  },
  users: {
    optional: true,
    label: 'Пользователи',
    nested: UserFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  userGroups: {
    optional: true,
    label: 'Группы',
    nested: UserGroupFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
